<div class="max-w-[443px]">
    <h1 mat-dialog-title class="flex items-center gap-2 font-medium text-[22px] leading-[22px] text-green-900 pt-1">
        <mat-icon class="icon-size-6 material-symbols-rounded text-green-600">check_circle</mat-icon>
        {{ title }}
    </h1>
    <mat-divider></mat-divider>
    <mat-dialog-content class="text-green-900">
        <div class="dialog-content-box bg-green-50 p-4 rounded-lg">
            <span class="text-lg break-words" [innerHTML]="content"></span>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="flex flex-row gap-4 justify-end pt-4 pb-6">
        <button *ngFor="let button of buttons" 
            mat-stroked-button 
            class="m-0 dialog-action-button"
            [ngClass]="button.class" 
            [ngStyle]="button.style"
            (click)="button.action()"
        >
            {{ button.label }}
        </button>
    </mat-dialog-actions>
</div>
